import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React, { useState } from "react";
import { DialogTitle, FormButton, FormInput } from "../../atoms";
import { toast } from "react-toastify";
type TemplateNameModalProps = {
  handleClose: () => void;
  name?: string;
  onChange: (value: string) => void;
};
function TemplateNameModal({ handleClose, name, onChange }: TemplateNameModalProps) {
  const [value, setValue] = useState(name);
  const handleSubmit = () => {
    if (!value) {
      toast.info("Template name is required.");
      return;
    }
    onChange(value);
  };
  return (
    <Dialog maxWidth="xs" open onClose={handleClose}>
      <DialogTitle title="Save Template" handleClose={handleClose} />
      <DialogContent>
        <FormInput label="Name" value={value} onChange={(e) => setValue(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <FormButton label="Continue" onClick={handleSubmit} />
      </DialogActions>
    </Dialog>
  );
}

export default TemplateNameModal;
